import styled, { css } from 'styled-components';

import { mediaMixin, Page } from '@zillow/constellation';

export const StyledPage = styled(Page)`
  ${mediaMixin(
    'xl',
    css`
      min-height: 900px;
    `,
  )};
`;
